<app-example-wrapper-seamless sectionHeading="Agencies">
    <div class="row">
        <div class="col-xl-12">
            <div class="card card-box mb-5">
                <div class="card-body">
                    <div class="d-flex justify-content-between pb-3">
                        <div class="search-wrapper">
                            <span class="icon-wrapper text-black">
                                <fa-icon [icon]="['fas', 'search']"></fa-icon>
                            </span>
                            <input type="text" class="form-control form-control-sm rounded-pill" pqlaceholder="Search..."
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="searchText">
                        </div>
                        <div>
                            <button class="btn btn-sm btn-primary" type="button" (click)="addAgencyService()"
                                id="addTeamMember">
                                <span class="btn-wrapper--icon">
                                    <fa-icon [icon]="['fas', 'plus']" class="opacity-8 font-size-xs" class="text-white">
                                    </fa-icon>
                                </span>
                                <span class="btn-wrapper--label">
                                    Add Agency
                                </span>
                            </button>
                            <button (click)="getData()" tooltip="Refresh" id="reloadEmployees"
                                class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                                type="button">
                                <span class="btn-wrapper--icon">
                                    <i class="ion-md-sync"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="allAgencyServices | tsearch:searchText; let filteredAgencies">
                        <div class="table-responsive table-scroll">
                            <table class="table table-hover table-striped table-bordered text-nowrap mb-3" [mfRowsOnPage]="100" #mf="mfDataTable" [mfData]="filteredAgencies" [mfActivePage]="activePage"> 
                                <thead>
                                    <tr>                                      
                                        <!-- <th class="bg-white text-left">Agency ID</th> -->
                                        <th class="bg-white text-left">Station</th>
                                        <th class="bg-white text-left">Agency</th>
                                        <th class="bg-white text-left">Contact First Name</th>
                                        <th class="bg-white text-left">Contact Last Name</th>
                                        <th class="bg-white text-left">Phone No</th>
                                        <th class="bg-white text-left">Status</th>
                                        <th class="bg-white text-left">&nbsp;</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr *ngFor="let aservice of mf.data ; let i=index">
                                        <!-- <td>{{aservice.AGENCY_ID}}</td> -->
                                        <td>{{aservice.STATION}}</td>
                                        <td>{{aservice.COMPANY_NAME}}</td>
                                        <td>{{aservice.CONTACT_FIRST_NAME}}</td>
                                        <td>{{aservice.CONTACT_LAST_NAME}}</td>
                                        <td>{{aservice.CONTACT_PHONE}}</td>
                                        <td class="text-left">
                                            <span class="badge bg-neutral-dark text-success"
                                            *ngIf="aservice.ACTIVE==true">Active</span>
                                            <span class="badge bg-neutral-dark text-warning"
                                            *ngIf="aservice.ACTIVE==false">Inactive</span>
                                        </td> 
                                        <td class="text-left">
                                            <button class="btn btn-sm btn-neutral-dark" tooltip="Edit" type="button" (click)="editAgencyService(aservice)">
                                                <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>

                                <tfoot>
                                    <tr>
                                        <td colspan="7">
                                            <span class="font-weight-bold text-primary">Total Agency Services: {{filteredAgencies.length}}
                                                </span>
                                            &nbsp;&nbsp;&nbsp;
                                            <span class="font-weight-bold text-success">Active :
                                                {{calculateActiveAgencies(filteredAgencies)}}</span>
                                            &nbsp;&nbsp;&nbsp;
                                            <span class="font-weight-bold text-warning">Inactive :
                                                {{calculateInActiveAgencies(filteredAgencies)}}</span>
                                            &nbsp;&nbsp;&nbsp;
                                            <mfBootstrapPaginator [rowsOnPageSet]="[200,400,600,800,1000]">
                                            </mfBootstrapPaginator>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-example-wrapper-seamless>
<notifier-container></notifier-container>
<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>

